/**
 * @name Actions
 * @description Botones de acciones CRUD del datagrid
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import styled from 'styled-components';

import { Icons, MUI } from '@styles';

// Acciones CRUD
const Actions = (props) => {
  const {
    canAdd,
    canEdit,
    canDelete,
    selectedRows,
    selectedRowsLength,
    onAdd,
    onEdit,
    onDelete
  } = props;

  return (
    <Styled.FlexActions>
      {/* Añadir */}
      {canAdd && (
        <MUI.Tooltip title={<Trans>GenericMessages.add</Trans>}>
          <Styled.ButtonFAB
            aria-label="add"
            onClick={onAdd}
          >
            <Icons.Add />
          </Styled.ButtonFAB>
        </MUI.Tooltip>
      )}

      {/* Editar */}
      {canEdit && (
        <MUI.Tooltip title={<Trans>GenericMessages.edit</Trans>}>
          <Styled.ButtonFAB
            aria-label="edit"
            disabled={selectedRowsLength !== 1}
            onClick={() => onEdit(selectedRows)}
          >
            <Icons.Edit />
          </Styled.ButtonFAB>
        </MUI.Tooltip>
      )}

      {/* Eliminar */}
      {canDelete && (
        <MUI.Tooltip title={<Trans>GenericMessages.delete</Trans>}>
          <Styled.LastButtonFAB
            aria-label="delete"
            disabled={selectedRowsLength === 0}
            onClick={() => onDelete(selectedRows)}
          >
            <Icons.Delete />
          </Styled.LastButtonFAB>
        </MUI.Tooltip>
      )}
    </Styled.FlexActions>
  );
};

Actions.propTypes = {
  // Boolean que indica si debe ocultar / mostrar el botón de añadir.
  canAdd: PropTypes.bool,
  // Boolean que indica si debe ocultar / mostrar el botón de editar.
  canEdit: PropTypes.bool,
  // Boolean que indica si debe ocultar / mostrar el botón de eliminar.
  canDelete: PropTypes.bool,
  // Registros seleccionados.
  selectedRows: PropTypes.array,
  // Número de registros seleccionados.
  selectedRowsLength: PropTypes.number,
  // Función a ejecutar cuando se agregará un elemento nuevo, al invocarla es necesario pasar como argumento event.
  onAdd: PropTypes.func,
  // Función a ejecutar cuando se editará un elemento, al invocarla es necesario pasar como argumento event.
  onEdit: PropTypes.func,
  // Función a ejecutar cuando se desea eliminar elementos, al invocarla es necesario pasar como argumento event.
  onDelete: PropTypes.func
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.FlexActions = styled.div`
  display: flex;
  flex-basis: 200px;
  flex-grow: 1;
  align-items: center;
  justify-content: flex-end;
`;

Styled.ButtonFAB = styled(MUI.ButtonFAB)`
  &.MuiFab-root {
    margin: 8px;
  }
`;

Styled.LastButtonFAB = styled(MUI.ButtonFAB)`
  &.MuiFab-root {
    margin: 8px 0px 8px 8px;
  }
`;

export default Actions;